import Image from "next/image";
import React from "react";
import config from "../config";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import cookie from "js-cookie";
import VisualSearch from "./components/visualSearch";
import convertPricePerSqmToSqft from "./utils/convertPricePerSqmToSqFt";

const UnbxdProductCard = (props) => {
  const url = `${props.product.productUrl.replace(
    "https://obl-new.orientbell.com",
    ""
  )}`;

  let [mrp, setMrp] = useState(convertPricePerSqmToSqft(props.product.price));
  let [sellingPrice, seSellingPrice] = useState(0);
  let [outOfStock, setOutOfStock] = useState("Add to cart");
  let [similerr, setSimilerr] = useState(false);
  const [base64content, setbase64content] = useState("");
  const [AvailableStock, setAvailableStock] = useState(0);
  const getBestPrice = async (pin) => {
    let apiresult = await axios.get(
      `https://obl-js.orientbell.com/api/product-availability-dev?sku=${props.product.sku}&pincode=${pin}&factory=${props?.product?.extraVariables?.factory}`
    );
    if (apiresult.data?.Plants?.length > 0) {
      let temparr = [];
      if (apiresult.data?.Plants.includes("Sikandrabad Plant")) {
        temparr.push(Number(apiresult.data?.erpStock?.skd_stock));
      }
      if (apiresult.data?.Plants.includes("Dora Plant")) {
        temparr.push(Number(apiresult.data?.erpStock?.dora_stock));
      }
      if (apiresult.data?.Plants.includes("Hoskote Plant")) {
        temparr.push(Number(apiresult.data?.erpStock?.hoskote_stock));
      }
      if (apiresult.data?.Plants.includes("West Zone")) {
        temparr.push(Number(apiresult.data?.erpStock?.west_zone_stock));
      }
      setAvailableStock(temparr.reduce((total, obj) => total + obj, 0));
    }
    if (apiresult.data?.transportOrder == 0) {
      return;
    } else if (apiresult.data?.devliverytime) {
      if (apiresult.data?.updated_price_ft) {
        seSellingPrice(apiresult.data?.updated_price_ft);
      }
    } else if (1 > apiresult.data.availableQty) {
      setOutOfStock("Out of Stock");
    } else if (apiresult.data.addesses == "" || !apiresult.data.devliverytime) {
      setOutOfStock("Not Deliverable");
      //trackProductUnavailability(props.product.sku, pin)
    }
  };

  async function convertImageToBase64(url) {
    // Replace 'obl-new' with 'images' in the URL
    url = url.replace("obl-new", "images");

    try {
      // Fetch the image as an arraybuffer
      const response = await axios.get(url, { responseType: "arraybuffer" });

      // Convert the response data (binary) to a buffer
      const buffer = Buffer.from(response.data, "binary");

      // Convert the buffer to a Base64 string
      const base64String = buffer.toString("base64");

      // Return the Base64 string
      return base64String;
    } catch (error) {
      console.error("Error fetching or converting image to Base64: ", error);
      throw error;
    }
  }

  useEffect(() => {
    setAvailableStock(props.product.Sum_Remaining_Quantity);
    //  setAvailableStock(props.product.stock ? props.product.stock : [Number(props.product.extraVariables.skd_stock), Number(props.product.extraVariables.dora_stock),Number(props.product.extraVariables.hoskote_stock),Number(props.product.extraVariables.west_zone_stock),].reduce((total, obj) => total + obj, 0))
    if (props.pinFromCityPage) {
      getBestPrice(props.pinFromCityPage);
    } else if (cookie.get("pincode")) {
      getBestPrice(cookie.get("pincode"));
    }
  }, []);

  return (
    <>
      {base64content && (
        <VisualSearch
          base64={base64content}
          setbase64content={setbase64content}
        />
      )}
      <div
        className="product-listing-col unbxd-result-tile"
        id={props.product.sku}
      >
        {Number(props.product.createdSinceInDays) <= 90 && (
          <span id="newicon">
            <img src="/New-Strip-icon.png" />
          </span>
        )}
        <div className="cate-pro-figure">
          <a href={url}>
            <img
              src={
                props.product?.imageUrl?.length ? props.product.imageUrl[0] : ""
              }
              width={265.67}
              height={265.67}
              alt={props.product.title}
              loading="lazy"
              // title={`${props.product.extraVariables.tile_type} ${props.product.extraVariables.tile_design} ${props.product.extraVariables.tile_size} ${props.product.extraVariables.finish[0]?.label}`}
            />
          </a>
          <div className="cam-bx">
            <img
              src="/compare_1.webp"
              onClick={() => props.addProductToComapre(props.product.uniqueId)}
              loading="lazy"
            />
          </div>
        </div>
        <div className="cate-pro-text">
          <div className="produ-view">
            <button
              // id="findsimilarlisting"
              className="syte-discovery"
              // data-sku={props.product.sku}
              // data-image-src={
              //   props.product.extraVariables.image_url
              // }
              data-placement="PLP"
              onClick={async () => {
                let img = await convertImageToBase64(
                  props.product?.imageUrl?.length
                    ? props.product.imageUrl[0]
                    : ""
                );
                setbase64content(img);
                // setSimilerr(props.product?.imageUrl?.length ? props.product.imageUrl[0] : "")
              }}
            >
              Find Similar
            </button>
            <div className="roomvo-container" data-product-type-str="">
              <button
                className="roomvo-stimr some-class"
                data-sku={props.product.sku}
                style={{ visibility: "hidden" }}
              >
                Try in my room
              </button>
            </div>
          </div>
          <div className="simi-name">
            <a href={url}>{props.product.title}</a>
          </div>
          <div className="produ-price">
            <ul>
              {sellingPrice && Number(mrp) > Number(sellingPrice) ? (
                <li className="mrp">
                  Offer price <strong>₹.</strong>{" "}
                  <span
                    style={{
                      textDecoration: "line-through",
                      marginRight: "5px",
                    }}
                  >
                    {" "}
                    {Math.round(mrp)}{" "}
                  </span>{" "}
                  <strong> {Math.round(sellingPrice)} /- Sq.ft </strong>
                </li>
              ) : (
                <li className="mrp">
                  MRP <strong> ₹ {Math.round(mrp)} /- Sq.ft</strong>
                </li>
              )}
              {/* <li className="mrp">MRP ₹ {mrp} {sellingPrice} /sq.ft</li> */}
              <li className="best-pri">
                <a href={url} className="buy-now-btn">
                  Buy Now
                </a>
              </li>
            </ul>
          </div>
          {props.product?.tileSize && (
            <div className="produ-size">
              <div className="produ-size-leftbox">
                Size {props.product?.tileSize[0]} ft
              </div>
              <div className="produ-size-rightbox">
                <span
                  style={{
                    display: "inline-block",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor:
                      AvailableStock > 0 && AvailableStock <= 100
                        ? "red"
                        : AvailableStock > 100 && AvailableStock <= 250
                        ? "orange"
                        : AvailableStock > 250 && AvailableStock <= 1000
                        ? "lightgreen"
                        : AvailableStock > 1000
                        ? "darkgreen"
                        : "grey",
                    marginRight: "5px",
                  }}
                ></span>
                {AvailableStock > 0 && AvailableStock <= 100
                  ? "Out of Stock"
                  : AvailableStock > 100 && AvailableStock <= 250
                  ? "Low Stock"
                  : AvailableStock > 250 && AvailableStock <= 1000
                  ? "Limited Stock"
                  : AvailableStock > 1000
                  ? "In Stock"
                  : "Out of Stock"}{" "}
              </div>
            </div>
          )}
          <div className="add-button">
            <a
              href={url}
              className="add-pro-btn"
              style={{
                backgroundColor:
                  outOfStock == "Not Deliverable in your Area"
                    ? "#a5a5a5"
                    : outOfStock == "Out of Stock"
                    ? "#ffcb08"
                    : "#0b9444",
              }}
            >
              {outOfStock}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnbxdProductCard;
